"use client";

import Link from "next/link";
import { ScrollReveal } from "@/components/ui/scroll-reveal";
import { ROOT_AUTH_URL, ROOT_PRIORITY_URL } from "@/constants/url";

const AUTH_HREF = `${ROOT_AUTH_URL}/login?redirect_path=${ROOT_PRIORITY_URL}&no_return=0`;

export function FinalCTA() {
  return (
    <section className="py-32 px-6 border-t border-white/[0.06]">
      <div className="max-w-3xl mx-auto text-center">
        <ScrollReveal>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight">
            Каждый день без аналитики —
            <br />
            <span className="text-white/50">это день, когда убыточные товары съедают прибыль</span>
          </h2>
          <p className="text-lg text-white/50 mt-6 max-w-xl mx-auto">
            30 дней бесплатно. Без карты. Отключите в любой момент.
          </p>
          <div className="mt-10">
            <Link
              href={AUTH_HREF}
              className="inline-flex items-center justify-center bg-white text-black rounded-lg px-8 py-4 font-semibold text-base hover:bg-white/90 transition-colors"
            >
              Попробовать бесплатно
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
